/**
 * Aideline Pro - Model Context Protocol (MCP) Entry Point
 * 
 * This is the main entry point for the MCP server implementation.
 * Import this to initialize and use the MCP server.
 */

import { getMCPServer, createMCPServer, MCPServer } from './server/MCPServer';
import { registerAllTools, getToolCategories, getToolStats } from './tools';

export { getMCPServer, createMCPServer, MCPServer };
export { MCPToolRegistry } from './server/MCPToolRegistry';
export { MCPResourceRegistry } from './server/MCPResourceRegistry';
export { MCPOrgContext } from './server/MCPOrgContext';
export { MCPLogger } from './server/MCPLogger';

export { registerAllTools, getToolCategories, getToolStats };
export { MCPTester } from './testing/MCPTester';

export type {
  MCPRequest,
  MCPResponse,
  MCPTool,
  MCPResource,
  MCPExecutionContext,
  MCPOrgConfig,
  MCPHealthStatus,
  MCPMetrics,
  MCPServerConfig
} from './types';

/**
 * Initialize the MCP server with all tools
 */
export async function initializeMCP(): Promise<void> {
  const server = getMCPServer();

  console.log('🚀 Initializing Aideline Pro MCP Server...');

  // Start server
  await server.start();

  // Register all tools
  await registerAllTools();

  // Log success
  const health = await server.getHealthStatus();
  console.log('✅ MCP Server initialized successfully');
  console.log(`   Version: ${health.version}`);
  console.log(`   Tools: ${health.metrics.totalRequests}`);
  console.log(`   Status: ${health.status}`);
}

/**
 * Quick health check
 */
export async function checkMCPHealth(): Promise<boolean> {
  try {
    const server = getMCPServer();
    const health = await server.getHealthStatus();
    return health.status === 'healthy';
  } catch (error) {
    console.error('MCP Health check failed:', error);
    return false;
  }
}
